module.exports = __webpack_public_path__ + "img/trio-page-3-silvex.ddc24947.jpg";